function isLoggedIn() {
  return !!localStorage.getItem('er_user');
}

function getLoggedInUser() {
  return JSON.parse(localStorage.getItem('er_user')) ?? null;
}

export { isLoggedIn, getLoggedInUser };
